(() => {
  if (customElements.get('kaotik-downloads')) return;

  class KaotikDownloads extends HTMLElement {
    connectedCallback() {
      // A deferred script normally sees all children; also support editor insertion.
      this.disconnect();
      if (!this.querySelector('[data-manual-input]')) {
        this.observer = new MutationObserver(() => {
          if (this.querySelector('[data-manual-input]')) this.connectedCallback();
        });
        this.observer.observe(this, { childList: true, subtree: true });
        return;
      }

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input = this.querySelector('[data-manual-input]');
      this.cards = Array.from(this.querySelectorAll('[data-manual-card]'));
      this.clear = this.querySelector('[data-manual-clear]');
      this.dialog = this.querySelector('[data-manual-dialog]');
      this.frame = this.querySelector('[data-manual-frame]');
      this.querySelector('[data-manual-search]').hidden = false;
      this.input.addEventListener('input', () => this.filter(), options);
      this.clear.addEventListener('click', () => {
        this.input.value = '';
        this.filter();
        this.input.focus();
      }, options);
      this.addEventListener('click', event => this.onClick(event), options);
      this.dialog.addEventListener('close', () => {
        this.frame.removeAttribute('src');
        this.trigger?.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.filter();
    }

    disconnectedCallback() {
      this.disconnect();
    }

    disconnect() {
      this.observer?.disconnect();
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.frame?.removeAttribute('src');
    }

    filter() {
      const query = this.input.value.trim().toLocaleLowerCase();
      let count = 0;
      this.cards.forEach(card => {
        card.hidden = !card.dataset.productName.toLocaleLowerCase().includes(query);
        if (!card.hidden) count++;
      });
      this.clear.hidden = this.input.value.length === 0;
      this.querySelector('[data-manual-empty]').hidden = count > 0;
      this.querySelector('[data-manual-status]').textContent = `${count} ${count === 1 ? 'product' : 'products'} found.`;
    }

    onClick(event) {
      if (event.target.closest('[data-manual-close]')) {
        this.dialog.close();
        return;
      }
      const link = event.target.closest('[data-manual-link]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      // Keep real PDF links working on mobile and when the browser has no dialog support.
      if (!matchMedia('(min-width: 750px)').matches || typeof this.dialog.showModal !== 'function') return;
      if (!new URL(link.href).pathname.toLowerCase().endsWith('.pdf')) return;

      event.preventDefault();
      this.trigger = link;
      const productName = link.closest('[data-manual-card]').dataset.productName;
      const title = `${productName} — ${this.dataset.previewLabel}`;
      this.querySelector('[data-manual-title]').textContent = title;
      this.frame.title = title;
      this.frame.src = link.href;
      this.querySelector('[data-manual-download]').href = link.href;
      this.dialog.showModal();
    }
  }

  customElements.define('kaotik-downloads', KaotikDownloads);
})();
